import React from "react";
import { SidebarLists } from "@/views/lists/SidebarLists.tsx";
import { useIsMobile } from "@/hooks/use-mobile.tsx";
import { SettingsIcon } from "lucide-react";
import { LogoView } from "@/components/LogoView.tsx";
import { useLocation } from "wouter";
import { AddMenu } from "@/blocks/AddMenu.tsx";

const MobileListsPage: React.FC = (props) => {
	const isMobile = useIsMobile();
	const [, setLocation] = useLocation();

	const handleSettings = () => {
		setLocation("/settings/account");
	};

	return (
		<div className={"p-2 bg-sidebar min-h-screen flex flex-col"}>
			<div className={"flex justify-between items-center"}>
				<LogoView size={60} />
				{isMobile && (
					<div className={"flex items-center gap-8 mr-4"}>
						<AddMenu />
						<SettingsIcon
							width={24}
							height={24}
							className={"cursor-pointer"}
							onClick={handleSettings}
						/>
					</div>
				)}
			</div>
			<SidebarLists />
		</div>
	);
};

export { MobileListsPage };
